import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { actions as analyticsActions } from "../Analytics.redux";
import history from "../../../helpers/history";

function AnalyticsAttribution() {
  const dispatch = useDispatch();

  const updateAttribution = useCallback(
    locationSearch => {
      const href = !!window && window?.location.href;
      dispatch(analyticsActions.update(href, locationSearch));
    },
    [dispatch]
  );

  useEffect(() => {
    updateAttribution(history?.location.search);

    const unlisten = history.listen((location, action) => {
      updateAttribution(location?.search);
    });

    return unlisten;
  }, [updateAttribution]);

  return null;
}

export default AnalyticsAttribution;
